export default "__VITE_ASSET__5jpZzjd8NgMb4PjyyBSg$w__"